import React, { useState } from 'react';
import { Pipette, Save, X, GitBranch, MousePointer2 } from 'lucide-react';

interface Props {
    onConfirm: (name: string) => void;
    onCancel: () => void;
    onStartPickingParent: () => void; // Dodane, aby naprawić błąd TS2322
    parentId: number | null;          // Dodane, aby naprawić błąd TS2322
    isPicking: boolean;               // Dodane, aby naprawić błąd TS2322
}

const PipeNamingModal: React.FC<Props> = ({
                                              onConfirm,
                                              onCancel,
                                              onStartPickingParent,
                                              parentId,
                                              isPicking
                                          }) => {
    const [name, setName] = useState('');

    // Jeśli użytkownik jest w trybie klikania w mapę, chowamy większość modala
    if (isPicking) {
        return (
            <div style={{
                position: 'fixed', bottom: '40px', left: '50%', transform: 'translateX(-50%)',
                backgroundColor: '#1a1a1a', padding: '15px 25px', borderRadius: '30px',
                border: '2px solid #4f46e5', color: 'white', zIndex: 4000,
                display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 10px 25px rgba(0,0,0,0.5)'
            }}>
                <MousePointer2 size={20} className="animate-pulse" />
                <span style={{ fontWeight: 600 }}>Kliknij w rurę na mapie, aby ją wybrać...</span>
            </div>
        );
    }

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center',
            justifyContent: 'center', zIndex: 3000, backdropFilter: 'blur(4px)',
            fontFamily: "'Inter', sans-serif"
        }}>
            <div style={{
                width: '400px', backgroundColor: '#1a1a1a', borderRadius: '16px',
                padding: '24px', border: '1px solid #333', color: 'white',
                boxShadow: '0 20px 40px rgba(0,0,0,0.5)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                    <div style={{ backgroundColor: '#2563eb33', padding: '10px', borderRadius: '12px' }}>
                        <Pipette color="#2563eb" size={24} />
                    </div>
                    <h2 style={{ margin: 0, fontSize: '20px' }}>Nowa rura</h2>
                </div>

                <div style={{ marginBottom: '20px' }}>
                    <label style={{ fontSize: '12px', color: '#666', marginBottom: '8px', display: 'block' }}>
                        Nazwa techniczna
                    </label>
                    <input
                        autoFocus
                        placeholder="np. Magistrala ul. Polna"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        style={{
                            width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #333',
                            backgroundColor: '#000', color: 'white', fontSize: '16px', boxSizing: 'border-box'
                        }}
                    />
                </div>

                {/* Sekcja wyboru rodzica */}
                <div style={{
                    padding: '15px', backgroundColor: '#262626', borderRadius: '12px',
                    marginBottom: '24px', border: parentId ? '1px solid #4f46e5' : '1px solid #333'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <GitBranch size={16} color={parentId ? "#818cf8" : "#666"} />
                            <span style={{ fontSize: '13px', color: parentId ? '#fff' : '#9ca3af' }}>
                                {parentId ? `Podpięto do rury ID: ${parentId}` : 'Brak rury nadrzędnej'}
                            </span>
                        </div>
                        <button
                            onClick={onStartPickingParent}
                            style={{
                                backgroundColor: '#4f46e5', color: 'white', border: 'none',
                                padding: '6px 12px', borderRadius: '6px', fontSize: '11px',
                                cursor: 'pointer', fontWeight: 600
                            }}
                        >
                            {parentId ? 'Zmień' : 'Wybierz z mapy'}
                        </button>
                    </div>
                </div>

                <div style={{ display: 'flex', gap: '12px' }}>
                    <button onClick={onCancel} style={{
                        flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #333',
                        backgroundColor: 'transparent', color: 'white', cursor: 'pointer', fontWeight: '600'
                    }}>Anuluj</button>
                    <button
                        onClick={() => name && onConfirm(name)}
                        disabled={!name}
                        style={{
                            flex: 1, padding: '12px', borderRadius: '8px', border: 'none',
                            backgroundColor: name ? '#2563eb' : '#333', color: 'white',
                            cursor: name ? 'pointer' : 'default', fontWeight: '600',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                        }}>
                        <Save size={18} /> Zapisz rurę
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PipeNamingModal;